import React from 'react';
import { Grid, makeStyles, Box } from '@material-ui/core';
import {
  EHandoverIcon,
  BedStatusIcon,
  DutyAssignIcon,
  WardDriveIcon,
  ArrowRightIcon,
  EquipmentIcon,
  TeleVisitIcon,
  AdmissionIcon,
  PatientSurveyIcon,
} from '../../Icon';
import { classNames } from '../../../utils';
import { i18n } from '../../../language';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    overflow: 'hidden',
    height: '11.813rem',
    borderRadius: '1.56rem',
    backgroundColor: '#ffffff',
    padding: '1.562rem 1.875rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.primary.main,
      '& $text': {
        color: '#ffffff',
      },
      '& $body': {
        backgroundColor: '#ffffff',
      },
      '& $arrow': {
        display: 'flex',
      },
      '& $bgIcon': {
        color: '#f2f6ff',
        opacity: 0.12,
      },
    },
    boxShadow: '0 0.625rem 1.25rem 0 rgba(198, 211, 230, 0.4)',
    marginTop: '1rem',
    marginRight: '1rem',
  },
  text: {
    fontSize: '1.875rem',
    fontWeight: 'bold',
    lineHeight: '2.2rem',
    marginTop: '1.5rem',
    color: theme.palette.font.main,
  },
  body: {
    width: '4.688rem',
    height: '4.688rem',
    backgroundColor: '#f1f6ff',
    borderRadius: '1.375rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    color: theme.palette.primary.main,
  },
  ehand: {
    fontSize: '2.2rem',
  },
  bed: {
    fontSize: '2.02rem',
  },
  duty: {
    fontSize: '2.02rem',
  },
  equipment: {
    fontSize: '2.25rem',
  },
  televisit: {
    fontSize: '2.25rem',
  },
  arrow: {
    width: '3.75rem',
    height: '3.75rem',
    backgroundColor: theme.palette.primary.dark,
    borderRadius: '50%',
    color: theme.palette.font.white,
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    '& $icon': {
      color: theme.palette.font.white,
      fontSize: '1.875rem',
    },
  },
  bgIcon: {
    '& $icon': {
      position: 'absolute',
      color: '#f2f6ff',
    },
    '& $ehand': {
      right: '-2.5rem',
      bottom: '-5.2rem',
      fontSize: '14rem',
      transform: 'rotate(-12deg)',
    },
    '& $bed': {
      right: '-1rem',
      bottom: '-3.2rem',
      fontSize: '14rem',
      transform: 'rotate(-12deg)',
    },
    '& $duty': {
      right: '-1rem',
      bottom: '-5.5rem',
      fontSize: '14rem',
      transform: 'rotate(-12deg)',
    },
    '& $equipment': {
      right: '-2rem',
      bottom: '-5.5rem',
      fontSize: '16rem',
      transform: 'rotate(-18deg)',
    },
  },
}));

const Icon = ({ text, classes }) => {
  switch (text) {
    case i18n.t('NAV_EHANDOVER'):
      return <EHandoverIcon className={classNames(classes.icon, classes.ehand)} />;
    case i18n.t('NAV_BED_STATUS'):
      return <BedStatusIcon className={classNames(classes.icon, classes.bed)} />;
    case i18n.t('NAV_DUTY_ASSIGN'):
      return <DutyAssignIcon className={classNames(classes.icon, classes.duty)} />;
    case i18n.t('NAV_EQUIPMENT'):
      return <EquipmentIcon className={classNames(classes.icon, classes.equipment)} />;
    case i18n.t('NAV_TELEVISIT'):
      return <TeleVisitIcon className={classNames(classes.icon, classes.equipment)} />;
    case i18n.t('NAV_WARD_DRIVE'):
      return <WardDriveIcon className={classNames(classes.icon, classes.equipment)} />;
    case i18n.t('NAV_ADMISSION'):
      return <AdmissionIcon className={classNames(classes.icon, classes.equipment)} />;
    case 'Patient Appreciation':
      return <PatientSurveyIcon className={classNames(classes.icon, classes.equipment)} />;
    default:
      break;
  }
};

export default function ToolKit(props) {
  const { onClick } = props;
  const classes = useStyles();

  return (
    <Grid item xs={12} lg={6}>
      <Box className={classes.root} onClick={onClick} id={props.id}>
        <span className={classes.bgIcon}>
          <Icon text={props.text} classes={classes} />
        </span>
        <Box display="flex" flexDirection="column" zIndex={2} justifyContent="flex-end" flex="1">
          <div className={classes.body}>
            <Icon text={props.text} classes={classes} />
          </div>
          <div className={classes.text}>{props.text}</div>
        </Box>
        <Box zIndex={2} className={classes.arrow}>
          <ArrowRightIcon className={classes.icon} />
        </Box>
      </Box>
    </Grid>
  );
}
